import React from "react";
import {
  Modal,
  TextField,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import { Link } from "react-router-dom";

const EditEventModal = ({
  open,
  onClose,
  currentEvent,
  setCurrentEvent,
  onSave,
  onDelete,
}) => {
  console.log(currentEvent);

  return (
    <Modal open={open} onClose={onClose}>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          backgroundColor: "white",
          padding: "20px",
          borderRadius: "8px",
          maxWidth: "400px",
          width: "100%",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
        }}
      >
        <div style={{ width: "100%" }}>
          <h3>Edit Event</h3>

          {/* Hide Order ID if type is "Custom" */}
          {currentEvent?.type !== "Custom" && (
            <TextField
              label="Order ID"
              value={currentEvent?.orderId}
              fullWidth
              disabled
              margin="normal"
              style={{ marginBottom: "15px" }}
            />
          )}

          <FormControl fullWidth margin="normal">
            <InputLabel>Status</InputLabel>
            <Select
              value={currentEvent?.statusToUpdate || ""}
              onChange={(e) =>
                setCurrentEvent({
                  ...currentEvent,
                  statusToUpdate: e.target.value,
                })
              }
              style={{ backgroundColor: "white" }}
            >
              <MenuItem value="ready_to_process">Ready to Process</MenuItem>
              <MenuItem value="processing">Processing</MenuItem>
              <MenuItem value="processed">Processed</MenuItem>
              <MenuItem value="delivered">Delivered</MenuItem>
              <MenuItem value="onHold">On Hold</MenuItem>
            </Select>
          </FormControl>

          <TextField
            label="OrderTag"
            value={currentEvent?.orderTag || ""}
            fullWidth
            margin="normal"
            style={{ marginBottom: "15px" }}
            disabled
          />

          {/* Hide Dealer Name if type is "Custom" */}
          {currentEvent?.type !== "Custom" && (
            <TextField
              label="Dealer Name"
              value={currentEvent?.dealerName || ""}
              fullWidth
              margin="normal"
              style={{ marginBottom: "15px" }}
              disabled
            />
          )}

          <TextField
            label="Order Status"
            value={currentEvent?.orderStatus || ""}
            fullWidth
            margin="normal"
            style={{ marginBottom: "15px" }}
            disabled
          />

          <TextField
            label="Remark"
            value={currentEvent?.remark || ""}
            onChange={(e) =>
              setCurrentEvent({ ...currentEvent, remark: e.target.value })
            }
            fullWidth
            margin="normal"
            multiline
            rows={3}
            style={{ marginBottom: "15px" }}
          />

          {/* Hide "View Order Details" link if type is "Custom" */}
          {currentEvent?.type !== "Custom" && (
            <div style={{ marginTop: "15px", textAlign: "center" }}>
              <Link
                to={`/order/order-detail/${currentEvent?.orderId}`}
                style={{
                  fontSize: "14px",
                  color: "#1976d2",
                  textDecoration: "none",
                  fontWeight: "bold",
                  marginBottom: "10px",
                  display: "inline-block",
                }}
              >
                View Order Details
              </Link>
            </div>
          )}

          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button variant="contained" color="primary" onClick={onSave}>
              Save
            </Button>
            <Button variant="contained" color="secondary" onClick={onDelete}>
              Delete
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default EditEventModal;
